<template>
  <div class="homeTile" id="informations">
    <div id="container">
      <div id="pic-container">
        <img id="pic" src="../assets/profilepic.jpg" alt="Avatar" />
      </div>

      <div id="terminals">
        <div id="terminal">
          <div class="fakeMenu">
            <div class="fakeButtons fakeClose"></div>
            <div class="fakeButtons fakeMinimize"></div>
            <div class="fakeButtons fakeZoom"></div>
          </div>
          <div class="fakeScreen" id="screen">
            <div id="data">
              ({{ percent_data }}%) Downloading Data
              <div class="bar">
                <div class="progress" v-bind:style="{ width: percent_data + '%' }"></div>
              </div>
            </div>
            <div id="files" style="display:none">
              ({{ percent_files }}%) Scratching Files
              <div class="bar">
                <div class="progress" v-bind:style="{ width: percent_files + '%' }"></div>
              </div>
            </div>
            <div id="virus" style="display:none">
              ({{ percent_virus }}%) 💀 Installing Virus 💀
              <div class="bar">
                <div class="progress virus" v-bind:style="{ width: percent_virus + '%' }"></div>
              </div>
            </div>
            <div id="info" style="display:none">
              ({{ percent_info }}%) Retrieving Informations
              <div class="bar">
                <div class="progress" v-bind:style="{ width: percent_info + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
        <div id="terminal2">
          <div class="fakeMenu">
            <div class="fakeButtons fakeClose"></div>
            <div class="fakeButtons fakeMinimize"></div>
            <div class="fakeButtons fakeZoom"></div>
          </div>
          <div class="fakeScreen" id="screen2">
            Hi!
            <ins>2</ins>
            <br />I'm
            <span style="color: white; background-color:#3297FD;">Edoardo Puglisi</span>
            <ins>2</ins>,
            <br />a
            <del>Pro Gamer</del>
            <del>Superhero</del> 
            Computer Engineer
          </div>
        </div>
      </div>
    </div>

    <div id="container2">
      <a href="https://github.com/machine1104">
        <img class="social-icon" src="../assets/github-logo.svg" />
      </a>
      <a href="https://www.instagram.com/edotcom_">
        <img class="social-icon" src="../assets/instagram-logo.svg" />
      </a>
      <a href="https://www.linkedin.com/in/edoardo-puglisi-a79270143/">
        <img class="social-icon" src="../assets/linkedin-logo.svg" />
      </a>
      <a href="https://twitter.com/machine1104">
        <img class="social-icon" src="../assets/twitter-logo.svg" />
      </a>
    </div>
    Scroll down for more...
  </div>
</template>

<script>
export default {
  data() {
    return {
      percent_data: 0,
      run_data: true,
      percent_files: 0,
      run_files: true,
      percent_virus: 0,
      run_virus: true,
      percent_info: 0,
      run_info: true,
      info: false,
      virus: true
    };
  },
  mounted: function() {
    this.bar();
  },
  methods: {
    bar: function() {
      const timer = setInterval(() => {
        if (this.run_data) {
          this.percent_data = this.percent_data + 1;
          this.percent_data == 100
            ? (this.run_data = false)
            : (this.run_data = true);
        }
        if (this.percent_data > 50 && this.run_files) {
          window.$("#files").css("display", "inline");
          this.percent_files = this.percent_files + 1;
          this.percent_files == 100
            ? (this.run_files = false)
            : (this.run_files = true);
        }
        if (this.percent_data > 70 && this.virus) {
          if (this.run_virus) {
            window.$("#virus").css("display", "inline");
            this.percent_virus = this.percent_virus + 1;
            this.percent_virus == 90
              ? (this.run_virus = false)
              : (this.run_virus = true);
          } else {
            this.percent_virus = this.percent_virus - 1;
            if (this.percent_virus == 50) {
              this.virus = false;
              this.info = true;
            }
          }
        }

        if (this.info && this.run_info) {
          window.$("#info").css("display", "inline");
          window.$("#virus").css("display", "none");
          this.percent_info = this.percent_info + 1;
          if (this.percent_info == 100) {
            this.run_info = false;
            window.$("#terminal2").css("visibility", "visible");
            window.$("#screen2").t({
              beep: false,
              caret: '<span style="color:#3498db;">▋</span>',
              fin: clearInterval(timer)
            });
          }
        }
      }, 20);
    }
  }
};
</script>
<style>
.bar {
  width: 100%;
  border: solid 3px rgb(32, 39, 47);
  border-radius: 25px;
  background: rgb(32, 39, 47)
}
.progress {
  width: 0%;
  border-radius: 20px;
  background: #00d742;
  height: 20px;
}

.virus {
  background: #9d252b;
}

.homeTile {  
  min-height: 100vh;
  background-color: #264653;
  color: #f5f5f5;
  overflow: hidden;
  text-align: center;
}

#container {
  justify-content: center;
  display: flex;

  padding-top: 10vh;
  height: fit-content;
  padding-bottom: 20px;
}

#terminals {
  padding-left: 5vw;
  text-align: left;
  position: relative;
}
#terminal {
  position: relative;
  z-index: 1;
  width: 45vw;
  border: 1px solid black;
  border-radius: 6px;
}
#terminal2 {
  position: absolute;
  left: 5vw;
  top: 5vh;
  z-index: 2;
  width: 35vw;
  -webkit-animation-delay: 10s;
  animation-delay: 10s;
  border: 1px solid black;
  border-radius: 6px;
  margin-left: 50px;
  visibility: hidden;
}
#pic {
  height: 20vw;
  width: 20vw;
  border-radius: 50%;
  border: 1px solid black;
}

#container2 {
  width: 100vw;
  height: fit-content;
  text-align: center;
}

.social-icon {
  width: 100px;
  padding: 20px;
  filter: invert(100%) sepia(2%) saturate(206%) hue-rotate(243deg)
    brightness(112%) contrast(92%);
}
.social-icon:hover {
  filter: invert(46%) sepia(58%) saturate(672%) hue-rotate(161deg)
    brightness(103%) contrast(80%);
}

/* TERMINAL */

.fakeButtons {
  height: 2vh;
  width: 2vh;
  border-radius: 50%;
  border: 1px solid #000;
  position: relative;
  top: 1vh;
  left: 1vh;
  background-color: #ff3b47;
  border-color: #9d252b;
  display: inline-block;
}

.fakeMinimize {
  left: 2vh;
  background-color: #ffc100;
  border-color: #9d802c;
}

.fakeZoom {
  left: 3vh;
  background-color: #00d742;
  border-color: #049931;
}

.fakeMenu {
  box-sizing: border-box;
  height: 4vh;
  background-color: #ddd;
  margin: 0 auto;
  box-shadow: -10px 10px 10px black;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
}

.fakeScreen {
  background-color: #ddd;
  box-sizing: border-box;
  color: #000;
  font-family: "Roboto Mono", monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: 400;
  font-size: 2vw;
  padding-left: 15px;
  padding-right: 20px;
  padding-bottom: 20px;
  padding-top: 10px;
  box-shadow: -10px 10px 10px black;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.fakeScreen .small {
  font-size: 1vw;
  font-weight: 300;
}
ins {
  text-decoration: none;
}
del {
  text-decoration: none;
}

[lineStart] {
  color: #3498db;
}

@media (min-width: 320px) and (max-width: 850px) {
  #container {
    display: block;
    height: fit-content;
    padding-top: 10px;
  }

  #container2 {
    height: fit-content;
    display: inline-block;
  }
  .social-icon {
    width: 20%;
    padding: 10px;
    display: inline-block;
  }

  #pic {
    height: 200px;
    width: 200px;
    border-radius: 50%;
    border: 1px solid black;
  }
  #terminals {
    padding-left: 5vw;
  }
  #terminal {
    position: relative;
    width: 90vw;
  }
  #terminal2 {
    position: absolute;
    left: 5vw;
    top: 5vh;
    z-index: 2;
    width: 75vw;
  }

  #pic-container {
    width: auto;
    text-align: center;
    height: 200px;
    padding: 10px;
  }
  .fakeScreen {
    font-size: 18px;
  }
  .fakeScreen .small {
    font-size: 14px;
  }
}
</style>
